// src/data/testimonials.js

import User1 from './user.png';
// import User2 from '../assets/testimonials/user2.png';
// import User3 from '../assets/testimonials/user3.png';

const testimonials = [
  {
    id: 1,
    name: 'John Doe',
    country: 'Traveler From UK',
    image: User1,
    feedback:
      '“StayVacay made our Dubai trip feel like home. The apartment was spotless, check-in was smooth, and support was always just a message away.”',
  },
  {
    id: 2,
    name: 'Amina Farah',
    country: 'Traveler From Kenya',
    image: User1,
    feedback:
      '“I loved the location and the comfort. Everything was seamless, and it really felt like a second home!”',
  },
  {
    id: 3,
    name: 'Carlos Mendez',
    country: 'Traveler From Mexico',
    image: User1,
    feedback:
      '“Best stay ever! From booking to check-out, the process was smooth and hassle-free.”',
  },
  {
    id: 4,
    name: 'Jad Taraby',
    country: 'Traveler From Lebanon',
    image: User1,
    feedback:
      '“I am in love.”',
  },
];

export default testimonials;
